import validate from "/app/build/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.4.1_@types+node@18.19.50_db0@0.3.2_encoding@0.1.13_eslint_c7fd73349cdb6398e0e83cf1cac8e7d9/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45middleware_45global from "/app/build/products/Survey/middleware/router-middleware.global.ts";
import manifest_45route_45rule from "/app/build/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.4.1_@types+node@18.19.50_db0@0.3.2_encoding@0.1.13_eslint_c7fd73349cdb6398e0e83cf1cac8e7d9/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  router_45middleware_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}